module.exports = __webpack_public_path__ + "img/pr-4.fe450294.png";